const Team = () => {
    const triggers = document.querySelectorAll(".js-team-trigger");
    const overlay = document.querySelector(".js-team-overlay");
    triggers.forEach((trigger) => {
        trigger.addEventListener("click", (event) => {
            const index = event.currentTarget.getAttribute("data-index");
            const bio = document.querySelector(`.js-team-bio[data-index="${index}"]`);
            togglePopup(bio);
        });
    });
    function togglePopup(bio) {
        if (bio.classList.contains("active") &&
            overlay?.classList.contains("active")) {
            bio.style.opacity = "0";
            if (overlay)
                overlay.style.opacity = "0";
            setTimeout(() => {
                bio.classList.toggle("active");
                overlay?.classList.toggle("active");
            }, 300);
        }
        else {
            bio.classList.toggle("active");
            overlay?.classList.toggle("active");
            setTimeout(() => {
                bio.style.opacity = "1";
                if (overlay)
                    overlay.style.opacity = "0.3";
            }, 1);
        }
    }
};
export default Team;
